import { createRoute } from '@tanstack/react-router'
import { DocumentDetailsPage } from '@/features/documents/pages/DocumentDetailsPage'
import { Route as documentsRoute } from '../documents'

export const Route = createRoute({
  getParentRoute: () => documentsRoute,
  path: '/$id',
  component: DocumentDetailsPage,
})
